import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { Axios } from "../Api/axios";
import { ALLSTD, ADMIN_ALL_CLASSES, ADMIN_ALL_SUBJECTS, ADMIN_ALL_LECTURES, ADMIN_ALL_EXCELLENT, ADMIN_GALLERY, ADMIN_ALL_NOTIFICATIONS, ADMIN_ALL_INTENSIVE, INSTITUTE_CODE } from "../Api/Api";
import Cookie from "cookie-universal";

const ADS_URL       = `/admin/all_ads?institute_code=${INSTITUTE_CODE}`;
const INTENSIVE_URL = ADMIN_ALL_INTENSIVE;

const CountsContext = createContext({ counts: {}, refreshCounts: () => {} });

export function CountsProvider({ children }) {
  const [counts, setCounts] = useState({});

  const refreshCounts = useCallback(() => {
    // only fetch admin counts when logged in
    if (!Cookie().get("rasheed")) return;

    const safe = (val) => (typeof val === "number" ? val : null);

    Promise.allSettled([
      Axios.get(`${ALLSTD}?limit=1&page=1`),
      Axios.get(ADMIN_ALL_CLASSES),
      Axios.get(ADMIN_ALL_SUBJECTS),
      Axios.get(ADMIN_ALL_LECTURES),
      Axios.get(INTENSIVE_URL),
      Axios.get(ADS_URL),
      Axios.get(ADMIN_ALL_EXCELLENT),
      Axios.get(ADMIN_GALLERY),
      Axios.get(ADMIN_ALL_NOTIFICATIONS),
    ]).then(([users, classes, subjects, lectures, intensive, ads, excellent, gallery, notifications]) => {
      setCounts({
        "/dashboard/users":
          safe(users.value?.data?.total) ?? (users.value?.data?.students?.length ?? null),
        "/dashboard/classes":
          classes.value?.data?.classes?.length ?? null,
        "/dashboard/categories":
          subjects.value?.data?.subjects?.length ?? null,
        "/dashboard/products":
          safe(lectures.value?.data?.count) ?? (lectures.value?.data?.lectures?.length ?? null),
        "/dashboard/T_Intensive":
          safe(intensive.value?.data?.total) ?? (intensive.value?.data?.data?.length ?? null),
        "/dashboard/T_Ads":
          intensive.value?.status === "fulfilled" ? (ads.value?.data?.Ads?.length ?? null) : null,
        "/dashboard/excellent":
          safe(excellent.value?.data?.count) ?? (excellent.value?.data?.students?.length ?? null),
        "/dashboard/gallery":
          gallery.value?.data?.images?.length ?? null,
        "/dashboard/notifications":
          notifications.value?.data?.notifications?.length ?? null,
      });
    });
  }, []);

  useEffect(() => { refreshCounts(); }, [refreshCounts]);

  return (
    <CountsContext.Provider value={{ counts, refreshCounts }}>
      {children}
    </CountsContext.Provider>
  );
}

export const useCounts = () => useContext(CountsContext);
